import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from './core/service/Error.service';


declare var gtag

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'proyecto-base-angular';
  showError = false;
  statusCode: number;
  errorMessage: string;

  constructor( private router: Router,
    private errorHandlingService: ErrorHandlingService
  ){
    const navEndEvents$ =  this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );

    navEndEvents$.subscribe((event : NavigationEnd) => {

      gtag('config', environment.GOOGLE_ANALYTICS, {
        'page_path': event.urlAfterRedirects
      });

    })

    this.errorHandlingService.error$.subscribe(error => {
      this.statusCode = error.statusCode;
      this.errorMessage = error.errorMessage;
      this.showError = true;
    });

  }
}
